<script>
	// imports
	import { acceptedFileUploadList, projectSettings, currentInvestigations, yesNoOptions } from "../../config";
	import { pageNumber, model } from "../../stores";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	import RadioGroup from "../../components/RadioGroup.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import Select from "../../components/Select.svelte";

	// props
	export let pageIndex = null;
	export let nextPage = null;
	export let previousPage = null;
	export let persistUrl = null;
	export let pageTitle = null;
	export let disabled = false;
	export let lastVisitedPage = null;
	export let title = null;

	let required = false;

	// dropzone config
	let id = "fileUploader";
	let options = {
		url: "/api/file-upload?token=" + $model.RegistrationToken,
		acceptedFiles: acceptedFileUploadList
	};

	// component state updating
	if (!disabled) {
		pageNumber.update((p) => pageIndex);
		$model.LastPageVisited = lastVisitedPage;
		document.title = pageTitle || `${projectSettings.classActionName} - Review`;
	}
</script>

<section>
	<FormRow>
		<FormColumn>
			<label for="InvestigationName" class:isrequired={required}
				>What investigation area do you wish to register for?</label
			>
			<Select
				{required}
				{disabled}
				id="InvestigationName"
				bind:value={$model.InvestigationName}
				optionList={currentInvestigations}
				textProperty="label"
				valueProperty="value"
			></Select>
		</FormColumn>
	</FormRow>

	<FormRow>
		<FormColumn>
			<label for="ContaminationZonePropertyOwned" class:isrequired={required}
				>Do you own property near the investigation area's Contamination Zone?</label
			>
			<RadioGroup
				{required}
				{disabled}
				id="ContaminationZonePropertyOwned"
				bind:value={$model.ContaminationZonePropertyOwned}
				optionList={yesNoOptions}
				labelProperty="label"
				valueProperty="value"
				orientation="horizontal"
			></RadioGroup>
		</FormColumn>
	</FormRow>

	{#if !disabled}
		<div class="form-group form-row">
			<div class="col-md-12 last">
				<NavigationButtons {persistUrl} {previousPage} {nextPage} pageName={title} tealiumTag={true}
				></NavigationButtons>
			</div>
		</div>
	{/if}
</section>

<style>
</style>
